module.exports = __webpack_public_path__ + "img/ad06.8655a678.png";